var _defs, _line, _line2, _path, _path2, _path3, _path4, _line3, _line4, _line5, _path5, _path6, _path7, _rect, _line6, _line7, _path8, _line8, _line9, _rect2, _rect3, _line0, _line1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAftermarketAlterationscopy2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448.55 448.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#f26725;stroke-linecap:round;stroke-linejoin:round;stroke-width:8.14px;}"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 285.1,
    y1: 186.14,
    x2: 285.1,
    y2: 263.02
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 192.5,
    y1: 263.02,
    x2: 192.5,
    y2: 153.29
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m266.17,170.68c-7.67,2.94-17.13,4.68-27.37,4.68-25.57,0-46.3-10.84-46.3-24.22,0-7.71,6.89-14.58,17.63-19.02"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m285.1,263.02c0,13.37-20.73,24.22-46.3,24.22s-46.3-10.84-46.3-24.22"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m285.1,232.65c0,13.37-20.73,24.22-46.3,24.22s-46.3-10.84-46.3-24.22"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m224.92,157.39v-54.59c0-7.67,6.22-13.88,13.88-13.88h0c7.67,0,13.88,6.22,13.88,13.88v54.59"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 238.8,
    y1: 195,
    x2: 238.8,
    y2: 237.27
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 211.43,
    y1: 187.49,
    x2: 211.43,
    y2: 229.77
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 266.17,
    y1: 187.49,
    x2: 266.17,
    y2: 229.77
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m173.86,152.86l-2.56-17.31h-20.49l-2.56,17.31c-6.38,1.45-12.35,3.96-17.73,7.35l-14.05-10.43-14.49,14.49,10.43,14.05c-3.38,5.38-5.89,11.35-7.35,17.73l-17.31,2.56v20.49l17.31,2.56c1.45,6.38,3.96,12.35,7.35,17.73l-10.43,14.05,14.49,14.49,14.05-10.43c5.38,3.38,11.35,5.89,17.73,7.35l2.56,17.31h20.49l2.56-17.31"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m174.19,239.97c-4.04,1.71-8.48,2.65-13.14,2.65-18.64,0-33.76-15.11-33.76-33.76s15.11-33.76,33.76-33.76c4.53,0,8.86.89,12.81,2.52"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m317.93,305.04h17.7c5.93,0,10.74,4.81,10.74,10.74v29.15c0,5.93-4.81,10.74-10.74,10.74h-17.7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 257.87,
    y: 318.71,
    width: 71.8,
    height: 23.29,
    rx: 6.07,
    ry: 6.07,
    transform: "translate(624.12 36.59) rotate(90)"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 252.82,
    y1: 318.78,
    x2: 271.46,
    y2: 318.78
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 271.46,
    y1: 341.93,
    x2: 252.82,
    y2: 341.93
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m224.3,320.43h35.75v10.54c0,5.14-4.18,9.32-9.32,9.32h-17.11c-5.14,0-9.32-4.18-9.32-9.32v-10.54h0Z",
    transform: "translate(572.53 88.18) rotate(90)"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 334.71,
    y1: 289.74,
    x2: 334.71,
    y2: 165.88
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 314.56,
    y1: 289.74,
    x2: 314.56,
    y2: 165.88
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 288.45,
    y: 144.83,
    width: 72.36,
    height: 21.05,
    rx: 5.49,
    ry: 5.49
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 288.45,
    y: 82.29,
    width: 72.36,
    height: 21.05,
    rx: 5.49,
    ry: 5.49
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 297.44,
    y1: 111.69,
    x2: 297.44,
    y2: 136.49
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 351.83,
    y1: 111.69,
    x2: 351.83,
    y2: 136.49
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAftermarketAlterationscopy2);
export default __webpack_public_path__ + "static/media/Aftermarket Alterations copy 2.475ddd76fa7fdbf3e017e7fe3ae914ab.svg";
export { ForwardRef as ReactComponent };